module.exports = __webpack_public_path__ + "img/logo.c7a5aa91.png";